import { render, staticRenderFns } from "./contactsView.vue?vue&type=template&id=77f1f606&scoped=true&"
import script from "./contactsView.vue?vue&type=script&lang=js&"
export * from "./contactsView.vue?vue&type=script&lang=js&"
import style0 from "./contactsView.vue?vue&type=style&index=0&id=77f1f606&lang=scss&scoped=true&"
import style1 from "./contactsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f1f606",
  null
  
)

export default component.exports